export const PILLARS = [
  {
    id: 'connection',
    name: 'Connection',
    shortName: 'Connection',
    description: 'Emotional closeness, trust, and feeling genuinely seen'
  },
  {
    id: 'desire',
    name: 'Desire',
    shortName: 'Desire',
    description: 'Feeling wanted, pursued, and actively desired'
  },
  {
    id: 'novelty',
    name: 'Novelty',
    shortName: 'Novelty',
    description: 'Freshness, curiosity, and new experiences'
  },
  {
    id: 'power',
    name: 'Power',
    shortName: 'Power',
    description: 'Tension, contrast, and dynamic roles'
  },
  {
    id: 'play',
    name: 'Play',
    shortName: 'Play',
    description: 'Lightness, ease, and spontaneity'
  }
];

export const CONTEXT_OPTIONS = [
  { value: 'women', label: 'With women', description: 'Experiences involving women, regardless of relationship type or setting' },
  { value: 'men', label: 'With men', description: 'Experiences involving men, regardless of relationship type or setting' },
  { value: 'romantic', label: 'In romantic connection', description: 'Experiences within an emotionally connected or relationship-based dynamic' },
  { value: 'casual', label: 'In casual connection', description: 'Experiences without ongoing emotional commitment or structure' },
  { value: 'power-exchange', label: 'In a power dynamic', description: 'Situations where one person leads and the other follows' },
  { value: 'fantasy', label: 'In fantasy', description: 'Experiences that are imagined, roleplayed, or not part of your everyday life' },
  { value: 'custom', label: 'Something else', description: 'A specific situation or context that isn\'t listed here' }
];

export const INTENT_OPTIONS = [
  { value: 'connection', label: 'Connection-focused', description: 'Emotional closeness, intimacy, feeling bonded' },
  { value: 'desire', label: 'Desire-driven', description: 'Feeling wanted, pursued, pulled into the moment' },
  { value: 'exploratory', label: 'Exploratory / Novel', description: 'Newness, variety, curiosity, discovery' },
  { value: 'power', label: 'Power / Dynamic', description: 'Tension, dominance, submission, polarity' },
  { value: 'playful', label: 'Playful / Free', description: 'Light, spontaneous, low-pressure' },
  { value: 'physical', label: 'Physical / Release', description: 'Primarily physical, focused on sensation or release' }
];

export const MODE_OPTIONS = [
  { value: 'current', label: 'Current reality', description: 'This reflects what your experience looks like right now' },
  { value: 'seeking', label: 'Something I want more of', description: 'This reflects something I want, or want to better understand' }
];
